"use client";

import { c as _c } from "react/compiler-runtime";
import { Controller, useFormContext } from "react-hook-form";
import { DateOfBirthInput } from "@/components/ui";
export default function DateOfBirthField(t0) {
  const $ = _c(11);
  const {
    className,
    required: t1
  } = t0;
  const required = t1 === undefined ? false : t1;
  const {
    control,
    formState: t2
  } = useFormContext();
  const {
    errors
  } = t2;
  const t3 = required && "Date of birth is required";
  let t4;
  if ($[0] !== t3) {
    t4 = {
      required: t3,
      validate: _temp
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== control || $[3] !== t4) {
    t5 = <Controller name="dateOfBirth" control={control} rules={t4} render={_temp2} />;
    $[2] = control;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== errors.dateOfBirth) {
    t6 = errors.dateOfBirth && <p className="mt-1 text-body text-status-error-text">{String(errors.dateOfBirth.message)}</p>;
    $[5] = errors.dateOfBirth;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== className || $[8] !== t5 || $[9] !== t6) {
    t7 = <div className={className}>{t5}{t6}</div>;
    $[7] = className;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}
function _temp2(t0) {
  const {
    field: t1
  } = t0;
  const {
    onChange,
    value: value_0
  } = t1;
  return <DateOfBirthInput className="mt-1" value={value_0} onChange={onChange} maxDate={new Date()} />;
}
function _temp(value) {
  if (!value) {
    return true;
  }
  const date = new Date(value);
  if (date > new Date()) {
    return "Date of birth cannot be in the future";
  }
  return true;
}